module.exports = __webpack_public_path__ + "img/international_airline_passengers.197360f4.jpg";